import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

// Universal "start every page at the top" guard. Two parts:
// 1) Disable the browser's scroll restoration so navigating never lands you
//    partway down / at the bottom of a page (the reported bug).
// 2) On every route change, force the window AND the document scroller to the
//    top, once synchronously and once on the next frame so late-mounting
//    content can't leave the user scrolled down.
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useLayoutEffect(() => {
    const toTop = () => {
      try {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      } catch (_e) {
        window.scrollTo(0, 0);
      }
      const el = document.scrollingElement || document.documentElement;
      if (el) el.scrollTop = 0;
      if (document.body) document.body.scrollTop = 0;
    };
    toTop();
    const raf = requestAnimationFrame(toTop);
    return () => cancelAnimationFrame(raf);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
